export function getValueWithAdditionalTooltip(
  currentValue: string,
  additionalValue: string,
  currentLabel: string = 'Current data',
  additionalLabel: string = 'Additional data',
): string {
  if (additionalValue !== null) {
    if (!currentValue) {
      return `${additionalLabel}: ${additionalValue}`;
    }
    return `${currentLabel}: ${currentValue}\n\n\n${additionalLabel}: ${additionalValue}`;
  }

  return currentValue ? `${currentLabel}: ${currentValue}` : '';
}
